import { render } from "./LegalMentionsPage.vue?vue&type=template&id=1da3b522&scoped=true"
import script from "./LegalMentionsPage.vue?vue&type=script&lang=js"
export * from "./LegalMentionsPage.vue?vue&type=script&lang=js"

import "./LegalMentionsPage.vue?vue&type=style&index=0&id=1da3b522&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da3b522"]])

export default __exports__